import React from 'react';
import { styles } from './Circle.css';
import { Base, LoadingSkeletonProps } from '../../Base/Base';
import { Shimmer } from '../../Shimmer/Shimmer';

export const Circle = ({
  shouldShimmer,
  height = { xs: '200px', md: '150px' },
  width = { xs: '200px', md: '150px' },
  ...baseProps
}: LoadingSkeletonProps) => {
  return (
    <Base {...baseProps} height={height} width={width} className={styles.container}>
      <Shimmer shouldShimmer={shouldShimmer} />
    </Base>
  );
};
